import { gql } from '@apollo/client';

export const SALE_DOCUMENTS_QUERY = gql`
  query SaleDocuments($saleId: ID!, $viewAs: SaleBidderLevel) {
    saleDocuments(sale_id: $saleId, view_as: $viewAs) {
      __typename
      sale_id
      folder_name
      documents {
        document_id
        file_name
        doc_type
        level
      }
      sale_keys {
        sale_key
        folder_name
        pools {
          offering_id
          folder_name
          documents {
            document_id
            file_name
            doc_type
            level
          }
          assets {
            loan_id
            folder_name
            documents {
              document_id
              file_name
              doc_type
              level
            }
          }
        }
      }
    }
  }
`;

export const MY_SALE_REVIEWER_ACCESS_QUERY = gql`
  query MySaleReviewerAccess($saleId: ID!) {
    mySaleReviewerAccess(sale_id: $saleId) {
      __typename
      active
    }
  }
`;

export const SALE_APPROVAL_QUERY = gql`
  query SaleApproval($saleId: ID!) {
    sale(sale_id: $saleId) {
      __typename
      ... on Sale {
        sale_id
        approved_by_user_id
        approved_at
        approved_document_count
      }
    }
  }
`;
